import { USER } from "../_constants/actionConstants";
import axios from "axios";
import qs from "qs";
import { BASE_URL } from "../_constants/urlConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";
import raiseError from "./raiseError";

const exists = (employeeNo) => async (dispatch) => {
  dispatch({ type: USER.EMPLOYEE_EXISTS });
  const apiEndpoint = `${BASE_URL}/api/Employee/${employeeNo}/Exists`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: USER.EMPLOYEE_EXISTS_FULFILLED });
    return res.data;
  } catch (e) {
    raiseError(USER.EMPLOYEE_EXISTS_REJECTED, e.response.data);
  }
};

/**
 * Get employee info by s/p#
 * @param {String} employeeNo - s/p#
 * @returns
 */
const get = (employeeNo) => async (dispatch) => {
  dispatch({ type: USER.FETCH_EMPLOYEE });
  const apiEndpoint = `${BASE_URL}/api/Employee/${employeeNo}`;
  try {
    const employeeRes = await axios.get(apiEndpoint);
    dispatch({ type: USER.FETCH_EMPLOYEE_FULFILLED });
    return employeeRes.data;
  } catch (e) {
    raiseError(USER.FETCH_EMPLOYEE_REJECTED, e.response.data);
  }
};

const getAll = (tabId, pageNo, pageSize, resetList) => async (dispatch) => {
  dispatch({ type: USER.FETCH_ALL_EMPLOYEES });
  const apiEndpoint = `${BASE_URL}/api/Employee/GetPaged/${pageNo}/${pageSize}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: USER.FETCH_ALL_EMPLOYEES_FULFILLED,
      tabId,
      employeeList: res.data.employeeList,
      resetList,
    });
    return res.data.pageCount;
  } catch (e) {
    raiseError(USER.FETCH_ALL_USERS_REJECTED, e.response.data);
  }
};

const getSuggestions = (tabId, searchString) => async (dispatch, getState) => {
  dispatch({ type: USER.FETCH_EMPLOYEE_SUGGESTIONS });

  const miscSessionData = getState().users.miscSessionData;
  // If history of the same search exists, load the cached results instead of
  // fetching anew.
  if (
    tabId in miscSessionData &&
    miscSessionData[tabId].employeeSearchHistory &&
    searchString in miscSessionData[tabId].employeeSearchHistory
  ) {
    dispatch({
      type: USER.FETCH_EMPLOYEE_SUGGESTIONS_FULFILLED,
      tabId,
      employeeList: miscSessionData[tabId].employeeSearchHistory[searchString],
      searchString,
    });
    return;
  }

  const apiEndpoint = `${BASE_URL}/api/Employee/Search/${searchString}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: USER.FETCH_EMPLOYEE_SUGGESTIONS_FULFILLED,
      tabId,
      employeeList: res.data.employeeList,
      searchString,
    });
    return;
  } catch (err) {
    raiseError(USER.FETCH_EMPLOYEE_SUGGESTIONS_REJECTED, err.response.data);
  }
};

const employeeActions = {
  exists,
  get,
  getAll,
  getSuggestions,
};

export default employeeActions;
